<div class="modal-header">
  <h4 class="modal-title">{{ 'password modification'|translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="userForm" (ngSubmit)="onFormSubmit()" id="ngForm">

    <div class="row">
      <div class="col-md-12">
        <label class="form-label">{{ 'password'|translate }} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm bg-gradient" type="password" placeholder="********" formControlName="password" [ngClass]="{'is-invalid': fc['password'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['password'].errors?.['required']">{{ 'this field is required'|translate }}</small>
        <div class="invalid-feedback" *ngIf="fc['password'].errors?.['minlength']">{{ 'password must be atleast 3 caracters long'|translate }}</div>
        <div class="invalid-feedback" *ngIf="fc['password'].errors?.['serverError']">
          {{ fc['password'].errors?.['serverError'] }}
        </div>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">

  <button form="ngForm" (submit)="onFormSubmit()" style="margin-right: 10px;" type="submit" class="btn btn-sm btn-primary m-r-10">
    <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
    <ng-template #isSaving>
      <i class="fa fa-spin fa-spinner me-2"></i>
    </ng-template>
    {{ 'save'|translate }}
  </button>
    <button  type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">
        <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>
        {{ 'close'|translate }}
    </button>


</div>